module.exports = __webpack_public_path__ + "static/media/Q.84368ebe.png";